<template>
<div class="container-detalle">
  <div class="nominados-lista-miunivisionarios">
    <div class="row mb-3 justify-content-center">
      <div class="col-12 mb-4">
        <div class="nominado-item" v-for="(n, ix) in nominados_todos" :key="ix">
          <div class="">
            <router-link :to="{name: 'miunivisionario_nominado', params: {'id': n.id}}">
              <img width="100%" :src="`${publicPath}assets/images/nominados/${n.id}.png`" />
              <div class="nominado-name">
                {{ n.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>

    </div>

  </div>
  
</div>

</template>

<style lang="scss">
  .nominados-lista-miunivisionarios {
    text-align: center;

    a {
      color: #000;
      text-decoration: none;
    }

    .nominado-name {
      display: inline-block;
      max-width: 120px;
    }

    .nominado-item {
      width: 100%;
      max-width: 200px;
      margin: 15px 5px;
      display: inline-block;
      vertical-align: top;

      @media (max-width: 600px) {
        width: 43%;
      }
    }
  }
</style>

<script>

export default {
  name: 'NewNominados',
  props: {
    nominados_todos: {
      type: Array,
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
